export default __webpack_public_path__ + "static/gen-350b6f08e6394900336bf3a43a299940.png";